/**
 * Tracks whether the viewport is narrower than the mobile breakpoint, updating
 * on resize. Mirrors the Image Index breakpoint (768px) but adds the resize
 * listener Image Index lacks, so layouts adapt live rather than only on mount.
 */
import { useEffect, useState } from "react"

const MOBILE_BREAKPOINT = 768

export function useIsMobile(): boolean {
  const [isMobile, setIsMobile] = useState(
    () => typeof window !== "undefined" && window.innerWidth < MOBILE_BREAKPOINT,
  )

  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth < MOBILE_BREAKPOINT)
    window.addEventListener("resize", onResize)
    return () => window.removeEventListener("resize", onResize)
  }, [])

  return isMobile
}
